import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Elastic, Linear, Power3, Timeline, TimelineLite, TweenLite} from "gsap";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";
import {TombOfAkhenatenTextStyles} from "../../config/TombOfAkhenatenTextStyles";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SoundManager} from "../../sound/SoundManager";
import {TombOfAkhenatenParsedGameData} from "../../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenGameMode} from "../../gameMode/TombOfAkhenatenGameMode";
import {FeaturePrice} from "../../server/data/FeaturePrice";
import {TombOfAkhenatenGameModuleConfig} from "../../TombOfAkhenatenGameModuleConfig";

export class TOAInitialWinCountUp extends BitmapWinCountUp {
    private _winWaysText: PIXI.Text;
    private _multiplierText: PIXI.Text;
    private _winTextShadow: PIXI.Sprite;
    private _endMultiplier: number;
    private _isCountUpSoundPlaying: boolean = false;
    private _hasMultiplierEndSoundPlayed: boolean = false;
    private _hasCountUpEndSoundPlayed: boolean = false;
    private _countUpComplete: boolean;
    private _gameData: TombOfAkhenatenParsedGameData;

    constructor() {
        super({
            font: {
                name: "NumbersWinCountUp",
                size: 200
            },
            align: "center",
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
    }

    public updateWinWays(winWays: number): void {
        let winWayNum: string = winWays.toString();
        if (winWays === 1) {
            this._winWaysText.text = winWayNum + Translation.translate(" way won");
        } else {
            this._winWaysText.text = winWayNum + Translation.translate(" ways won");
        }
    }

    private isFreeSpin(mode: string): boolean {
        return mode == TombOfAkhenatenGameMode.FREESPIN || mode == TombOfAkhenatenGameMode.FS_RESPIN_FIRST ||
            mode == TombOfAkhenatenGameMode.FS_RESPIN_SECOND || mode == TombOfAkhenatenGameMode.FS_RESPIN_FINAL;
    }

    public getCountUpAnimation(totalWinWaysWon: number, from: number, to: number, duration: number, multiplier: number, winRatioConfig: IWinRatioConfig | null, data: TombOfAkhenatenParsedGameData): Timeline {
        this._gameData = data;
        //this._countUpContainer.scale.set(0.75); //reset count-up container to fix issue #125
        this._multiplierText.text = "x" + 1; //to fix #128
        this.updateWinWays(totalWinWaysWon);
        this._endMultiplier = multiplier;
        const oriNumber: number = to;//MathHelper.floorToDecimals(to / multiplier, 2);
        const timeline: TimelineLite = new TimelineLite();

        let isMediumAndLargeWin: boolean = false;

        if (winRatioConfig && winRatioConfig.type && (winRatioConfig.type === "medium" || winRatioConfig.type === "large")) {
            isMediumAndLargeWin = true;
        }

        timeline.add([
            () => {
                //this._countUp.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.7 / this.getScale(multiplier);
                this._countUp.visible = true;
                //this._countUpContainer.scale.set(1, 1);
                if (isMediumAndLargeWin) {
                    this._isCountUpSoundPlaying = true;
                    SoundManager.playMediumLargeWinCountUpSound();
                }
            },
            this._countUp.getCountUpAnimation(from, oriNumber, {duration: duration, ease: Power3.easeInOut})
        ], 0);

        timeline.add([
            () => {
                if (multiplier > 1) {
                    TweenLite.fromTo(this._multiplierText, 0.2, {alpha: 0}, {alpha: 1});
                }
                TweenLite.fromTo(this._countUp, 0.2, {alpha: 0}, {alpha: 1});
                TweenLite.fromTo(this._winTextShadow, 0.2, {alpha: 0}, {alpha: 1});
                TweenLite.fromTo(this._winWaysText, 0.2, {alpha: 0}, {alpha: 1});
            }
        ], 0);

        if (this.isFreeSpin(data.mode)) {
            timeline.add(() => {
                SoundManager.stopMediumLargeWinCountUpSound();

                // #437
                multiplier == 1 && !TombOfAkhenatenGameConfig.instance.WIN_BELOW_STAKE && SoundManager.playMultiplierCountUpEndsSound();
            });
        } else {
            timeline.add(() => this.stopCountUpSound());
        }

        if (multiplier > 1) {
            //const levelTime:number = multiplier > 10 ? (1 / multiplier) : 0.4;
            const levelTime:number = multiplier > 10 ? 0.25 : 0.4;
            for (let m: number = 1; m <= multiplier; m++) {
                const showNumber: number = oriNumber * m;
                const scale: number = this.getScale(m, multiplier);
                timeline.add([
                    () => {
                        this._multiplierText.text = "x" + m;
                    }
                ]);
                timeline.add([
                    () => {
                        if (this.isFreeSpin(data.mode)) {
                            if (m === multiplier) {
                                SoundManager.stopMultiplierCountUpSound();

                                // #437
                                if (!TombOfAkhenatenGameConfig.instance.WIN_BELOW_STAKE) {
                                    SoundManager.playMultiplierCountUpEndsSound();
                                }
                                this._hasMultiplierEndSoundPlayed = true;
                            } else {
                                // #437
                                if (!TombOfAkhenatenGameConfig.instance.WIN_BELOW_STAKE) {
                                    SoundManager.playMultiplierCountUpSound();
                                }
                            }
                        }
                    },
                    this._countUp.getCountUpAnimation(showNumber, showNumber, {duration: 0.01}),
                    TweenLite.to(this._countUp.scale, 0.01, {
                        x: scale,
                        y: scale,
                        ease : Elastic.easeOut.config(2, 1)
                    }),
                ]);
                if(isMediumAndLargeWin){
                    timeline.add(TweenLite.to(this, levelTime, {})); // pump level
                }
            }
        }
        timeline.add(TweenLite.to({}, 1, {})); // add 1s delay to avoid conflicts on Autoplay
        return timeline;
    }

    public abort(endValue: number, isAborted: boolean, multiplier: number, isBigWin: boolean): Timeline | null {
        if (isBigWin) {
            return null;
        }

        if (this._countUpComplete) {
            return null;
        }

        this._endMultiplier = multiplier;
        const timeline: TimelineLite = new TimelineLite();
        if (isAborted) {
            timeline.add(this.getAbortAnimation(endValue, multiplier));
            timeline.add(this.stay());
        }

        return timeline;
    }

    public getEndingAnimation(endValue: number, forceVisible:boolean = false, totalWinWays:number = -1, payoutMp:number = 1, data: TombOfAkhenatenParsedGameData | undefined  = undefined): Timeline {
        const timeline: TimelineLite = new TimelineLite();
        let finalScale: number = this.getFinalScale();

        if(!this._gameData && data) {
            this._gameData = data;
        }

        timeline.add([
            () => {

            },
            //#276
            () => SlotGame.winFieldController.showWinField(undefined, undefined, TombOfAkhenatenGameModuleConfig.featurePrice.isWinBelowStake()),
            this._countUp.getCountUpAnimation(endValue, endValue, {
                duration: 0,
                scaling: {from: 1, to: finalScale}
            })]
        );
        timeline.add(() => {
            if(forceVisible) {
                if(totalWinWays > 0) {
                    //this.initAnimations();
                    this.updateWinWays(totalWinWays);
                }
                this._countUp.visible = true;
                this._countUp.alpha = 1;
                this._winWaysText.visible = true;
                this._winWaysText.alpha = 1;
                this._winTextShadow.visible = true;
                this._winTextShadow.alpha = 1;

                if(payoutMp > 1) {
                    this._multiplierText.text = "x" + payoutMp;
                    this._multiplierText.visible = true;
                    this._multiplierText.alpha = 1;
                }
            }

        });
        timeline.add([
            //#276
            //() => SlotGame.winFieldController.showWinField(),
            TweenLite.to(this._countUp, 0.5, {alpha: 0}),
            TweenLite.to(this._winWaysText, 0.5, {alpha: 0}),
            this.getHideMultiplier(0.5)
        ], `+=0.5`);
        timeline.add(() => {
            this._countUpContainer.y = 0;
            this._countUpComplete = false;
            this._isCountUpSoundPlaying = false;
            this._hasCountUpEndSoundPlayed = false;
            this._hasMultiplierEndSoundPlayed = false;
            //this._countUpContainer.scale.set(0.75);
                if(forceVisible) {
                    /*this._countUp.visible = false;
                    this._winWaysText.visible = false;
                    this._winTextShadow.visible = false;
                    this._multiplierText.visible = false;

                    this._winWaysText.alpha = 0;
                    this._winTextShadow.alpha = 0;

                    if(payoutMp > 1) {
                        this._multiplierText.alpha = 0;
                        this._multiplierText.visible = false;
                    }*/
                }

        });
        return timeline;
    }

    private getFinalScale(): number{
        let finalScale: number = 1.4;

        if(this._gameData && this.isFreeSpin(this._gameData.mode)){
            let winRatioConfig = this._gameData.currentWinRatioConfig;
            if (winRatioConfig && winRatioConfig.type && (winRatioConfig.type === "tiny" || winRatioConfig.type === "small")) {
                finalScale = 1;
            }
        }else{
            finalScale = 1;
        }

        return finalScale;
    }

    public stay(): Timeline {
        this._countUpComplete = true;
        this.stopCountUpSound();
        const timeline: TimelineLite = new TimelineLite();
        timeline.add(() => {
            if (this._endMultiplier > 1 && !this._hasMultiplierEndSoundPlayed) {
                this._hasMultiplierEndSoundPlayed = true;
                this._hasCountUpEndSoundPlayed = true;
            }
        });
        // TODO: timeline.add(()=> EventHandler.dispatchEvent(new GameEvent(SoundEvent.PLAY_SOUND_EFFECT, TombstoneSoundConfig.instance.COUNT_UP_BACK)));
        /*timeline.add(TweenLite.to(this._countUpContainer.scale, 0.9, {
            x: 0.75,
            y: 0.75,
            ease: Elastic.easeOut.config(2, 0.75)
        }));*/
        return timeline;
    }

    protected getAbortAnimation(endValue: number, multiplier: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                //this._countUp.maxTextWidth = GameConfig.instance.REEL_AREA_WIDTH * 0.7 / this.getScale(multiplier);
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                //this._countUpContainer.scale.set(0.75, 0.75);
            },
            () => SlotGame.winFieldController.showWinField(),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01})
        ]);
        if (multiplier > 1) {
            const scale: number = this.getScale(multiplier);
            /*timeline.add(TweenLite.to(this._countUpContainer.scale, 0.2, {
                x: scale,
                y: scale,
                ease: Elastic.easeOut.config(2, 1)
            }), 0)*/
        }

        return timeline;
    }

    protected initAnimations(): void {
        super.initAnimations();

        this.position.set(TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.5 - 20, TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT * 0.5 + TombOfAkhenatenGameConfig.instance.REEL_AREA_POS_Y);
        this._countUp.position.set(0, 50);
        this.scale.set(0.75);

        this._multiplierText = new PIXI.Text("x1", TombOfAkhenatenTextStyles.TOA_TEXT_FONT);
        this._multiplierText.position.set(TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.5, 250);
        this._multiplierText.anchor = new PIXI.Point(0.5, 0.5);
        this._multiplierText.scale.set(0.85);
        this._multiplierText.alpha = 0;
        this._multiplierText.name = "multiplierText";

        this._winWaysText = new PIXI.Text(Translation.translate(""), TombOfAkhenatenTextStyles.TOA_TEXT_FONT);
        this._winWaysText.position.set(TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.5, 480);
        this._winWaysText.anchor.set(0.5);
        this._winWaysText.scale.set(0.476);
        this._winWaysText.alpha = 0;
        this._winWaysText.name = "winWaysText";

        this._winTextShadow = new PIXI.Sprite(GameResources.getTextures("winAmountShadow")[0]);
        this._winTextShadow.position.set(TombOfAkhenatenGameConfig.instance.REEL_AREA_WIDTH * 0.5, (TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT * 0.5) + TombOfAkhenatenGameConfig.instance.REEL_AREA_POS_Y);
        this._winTextShadow.anchor.set(0.5);
        this._winTextShadow.scale.set(1.5);
        this._winTextShadow.alpha = 0;
        this._winTextShadow.name = "countUpShadow";

        StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChildAt(this._winTextShadow, 0);
        StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this._multiplierText, this._winWaysText);
        StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this);
    }

    private stopCountUpSound(): void {
        SoundManager.stopMediumLargeWinCountUpSound();
        if (this._isCountUpSoundPlaying) {
            SoundManager.playMediumLargeFinalCountSound();
            this._isCountUpSoundPlaying = false;
        }
    }

    private getScale(multiplier:number, finalMultiplier:number = 1):number {
        let maxScale:number = this.getFinalScale(),
            minScale:number = 1;

        let retVal: number = (((maxScale - minScale) / finalMultiplier) * multiplier) + minScale;

        return retVal;
    }

    /*private getShowMultiplier(multiplier: number, duration: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (multiplier < 2) {
            return tl;
        }
        tl.add([
            () => this._multiplierText.text = "x" + multiplier,
            new TweenLite(this._multiplierText, 0.01, {alpha: 1, ease: Linear.easeNone}),
        ]);
        return tl;
    }*/

    private getHideMultiplier(duration: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._winTextShadow, duration * 0.3, {alpha: 0, ease: Linear.easeNone}),
            new TweenLite(this._multiplierText, duration * 0.3, {alpha: 0, ease: Linear.easeNone}),
        ]);
        return tl;
    }
}
